import React from "react";
import { default as WeekShifts } from "components/Dashboard/Dashboard_WeekShifts"

const Card_WeekShifts = (props) => {
	// console.log(props);

	return (
		<article className="card card-week-plan">
			<WeekShifts />
		</article>
	);
};

export default Card_WeekShifts;